import { AutogenModelCarrierPlan, AutogenRowCarrierPlan } from "@mcleod/crm/src/models/autogen/AutogenModelCarrierPlan";

export class ModelCarrierPlan extends AutogenModelCarrierPlan<RowCarrierPlan> {
	constructor() {
		super(RowCarrierPlan);
	}
}

export class RowCarrierPlan extends AutogenRowCarrierPlan {
}